import React /*, { useState }*/ from 'react'
import { Link } from 'gatsby'
import Layout from '../../components/Layout'
import Seo from '../../components/Seo'
// import { submitCesspool } from '../../helper/handles'

const Cesspool_vehicle = () => {

	// const [cesspoolForm, setCesspoolForm] = useState({
	// 	"full_name": "",
	// 	"phone_number": "",
	// 	"address1": "",
	// 	"address2": "",
	// 	"city": "",
	// 	"district": "Kalahandi",
	// 	"state": "Odisha"
	// })

	// const [isLoading, setIsLoading] = useState(false);
	// const [formMsg, setFormMsg] = useState({
	// 	type: '',
	// 	msg: ''
	// })

	// const validateAndSetNumber = e => {
	// 	const val = e.target.value
	// 	if (val.length < 11 && !isNaN(val)) {
	// 		setCesspoolForm({ ...cesspoolForm, phone_number: val })
	// 	}
	// }

	// const handleSubmit = e => {
	// 	e.preventDefault()
	// 	setIsLoading(true)

	// 	const fData = {
	// 		...cesspoolForm,
	// 		address: [cesspoolForm.address1, cesspoolForm.address2, cesspoolForm.city, cesspoolForm.district, cesspoolForm.state].filter(x => x).join(', ')
	// 	}
	// 	delete fData['address1']
	// 	delete fData['address2']
	// 	delete fData['city']
	// 	delete fData['district']
	// 	delete fData['state']

	// 	submitCesspool(fData, (res) => {
	// 		setIsLoading(false)
	// 		if (res?.name === 'Error') {
	// 			setFormMsg({
	// 				type: 'error',
	// 				msg: 'Unable to send request. Try after sometime.'
	// 			})

	// 		} else {
	// 			setFormMsg({
	// 				type: 'success',
	// 				msg: 'Your request has been submitted. We will review it and call you on the phone number provided. Please note that this form has only submitted your booking request. Confirmation is PENDING.'
	// 			})
	// 		}
	// 		setCesspoolForm({
	// 			"full_name": "",
	// 			"phone_number": "",
	// 			"address1": "",
	// 			"address2": "",
	// 			"city": "",
	// 			"district": "Kalahandi",
	// 			"state": "Odisha"
	// 		})

	// 	})
	// }

	return (
		<Layout>
			<Seo title={`Cesspool Vehicles | NAC, Dharamgarh`} />
			<header className="header">
				<div className="header__jumbotron baseWrap df jcsb fww">
					<h2 className="sec_heading">Cesspool Vehicles</h2>
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<Link to="/">Home</Link>
						</li>
						<li className="breadcrumb-item">
							<span>Online Booking</span>
						</li>
						<li className="breadcrumb-item active">
							<span>Cesspool Vehicles</span>
						</li>
					</ol>
				</div>
			</header>
			<section className="sec sec_page df">
				<div className="baseWrap">
					<div className="contentWrap h100 ma shadow df aic">
						<div className="w100 blurBg cesspoolBlur df jcc aic">
							<div className="offContent">
								<h2 className="sec_heading">Online booking is temporarily not available.</h2>
								<p className="text">It will be back soon.</p>
							</div>
						</div>
						{/* <div className="w100">
							<h3 className="sec_heading tac" style={{ 'marginBottom': '1rem' }}>Request for Cesspool Vehicle</h3>
							<form action="#!" className="form w100 ma font2" autoComplete="off" spellCheck="false" onSubmit={handleSubmit}>
								<div className="grid2">
									<div className="input_group">
										<label htmlFor="cess_name">Full Name</label>
										<input type="text" className="input_control" id="cess_name" required value={cesspoolForm.full_name} onInput={(e) => { setCesspoolForm({ ...cesspoolForm, 'full_name': e.target.value }) }} />
									</div>
									<div className="input_group">
										<label htmlFor="cess_phone">Phone Number</label>
										<div className="input_preset">
											<span>+91</span>
											<input type="tel" id="cess_phone" required value={cesspoolForm.phone_number} onInput={validateAndSetNumber} />
										</div>
									</div>
								</div>
								<div className="input_group">
									<label htmlFor="cess_addr1">Address Line 1</label>
									<input type="text" className="input_control" id="cess_addr1" required value={cesspoolForm.address1} onInput={(e) => { setCesspoolForm({ ...cesspoolForm, 'address1': e.target.value }) }} />
								</div>
								<div className="input_group">
									<label htmlFor="cess_addr2">Address Line 2 <span className="sm muted">(Optional)</span></label>
									<input type="text" className="input_control" id="cess_addr2" value={cesspoolForm.address2} onInput={(e) => { setCesspoolForm({ ...cesspoolForm, 'address2': e.target.value }) }} />
								</div>
								<div className="grid3">
									<div className="input_group">
										<label htmlFor="cess_city">Village/Town</label>
										<input type="text" className="input_control" id="cess_city" required value={cesspoolForm.city} onInput={(e) => { setCesspoolForm({ ...cesspoolForm, 'city': e.target.value }) }} />
									</div>
									<div className="input_group">
										<label htmlFor="cess_district">District</label>
										<input type="text" className="input_control" id="cess_district" required readOnly value={cesspoolForm.district} onInput={(e) => { setCesspoolForm({ ...cesspoolForm, 'district': e.target.value }) }} />
									</div>
									<div className="input_group">
										<label htmlFor="cess_state">State</label>
										<input type="text" className="input_control" id="cess_state" required readOnly value={cesspoolForm.state} onInput={(e) => { setCesspoolForm({ ...cesspoolForm, 'state': e.target.value }) }} />
									</div>
								</div>
								<div className="input_group df jcsb aic fww" style={{ 'marginTop': '2rem' }}>
									<span className={`form_msg text ${formMsg.type}`}>{formMsg.msg}</span>
									{isLoading ? (
										<button className="btn btn_icon" disabled>
											<i className="material-icons-round">loop</i>
											<span>Submitting ...</span>
										</button>
									) : (
											<button type="submit" className="btn btn_icon right">
												<span>SUBMIT</span>
												<i className="material-icons-round">send</i>
											</button>
										)}
								</div>
							</form>
						</div> */}
					</div>
				</div>
			</section>
		</Layout>
	)
}

export default Cesspool_vehicle
